//import {USERLIST} from '../actions';
import {findIndex} from 'lodash';
import {menuStandard,btnStandard} from '../../config';

let namespace = 'roleAuth_';

const initialState = {  
	  data:[],
	  dataLoading: true,	  
	  dataFetchProps: {order:[['id','desc']],status:'待批准',include:[{model:'client',as:'m_orderclient',attributes:['cust_name','bank_id']}]},
      modalVisible: false,
	  modalType: 'create',		  
	  selectedRow: {},  
	  selectedRowIndex: -1,  
	  selectedRows: [],  
	  clickRow:{},
      selectedRowKeys: [],	  
	  pagination: {
		  showSizeChanger: true,
		  showQuickJumper: true,
		  showTotal: (total, range) => `${range[0]}-${range[1]} / ${total}`,
		  pageSizeOptions: ['5','10', '20', '40', '100'],
		  defaultPageSize: 5,
		  pageSize:5,
		  current: 1,		 
		},
	  menuStandard:[...menuStandard],
	  btnStandard:[...btnStandard],
	  hasTreeKeys:{},	
	  roleList:[],
	  selectRole:null,
	  roleAuth:null,	  
	  
}

export default function(state=initialState, action) {
  switch (action.type) {
    case namespace+"forcedUpdate": {		
	
      return {
        ...state,
        ...action.payload
      }
    }
	case namespace+"updateDataById": {
		
		let newData = state.data
		
		let {selectedRowIndex, id} = action.payload		
		
		newData[selectedRowIndex] = action.payload.data		
		
		return {...state, selectedRow: action.payload.data, data: newData}
	}

	case namespace+"deleteDataById": {
		
		let newData = state.data
		let {selectedRowIndex, id} = action.payload
		let i = selectedRowIndex ? selectedRowIndex : findIndex(newData, {id: id})
		newData.splice(i,1)
		
		return {...state, data: newData}
	}
	
	case namespace+"addOneRowData": {
		
		return {...state, data: [action.payload.data, ...state.data]}
	}
	
	case namespace+"RemoveDataByIndex": {
		
		let newData = state.data;		
		let {selectedRowIndex} = action.payload		
		newData.splice(selectedRowIndex,1)
		
		return {...state, data: newData}
	}
	
    default:
      return state;
  }
}